import { render, staticRenderFns } from "./WCostCenter.vue?vue&type=template&id=5399c340&"
import script from "./WCostCenter.vue?vue&type=script&lang=ts&"
export * from "./WCostCenter.vue?vue&type=script&lang=ts&"
import style0 from "./WCostCenter.vue?vue&type=style&index=0&id=5399c340&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports